import React, { ForwardedRef } from "react";
import MuiMenuItem from "@mui/material/MenuItem";

import { useMenuItemStyles } from "./MenuItem.styles";
import { MenuItemProps } from "./MenuItem.types";

function MenuItem(props: MenuItemProps, ref: ForwardedRef<HTMLLIElement>) {
  const { children, disabled, ...other } = props;

  const menuItemClasses = useMenuItemStyles();

  return (
    <MuiMenuItem
      {...other}
      disableRipple
      ref={ref}
      aria-disabled={disabled}
      classes={menuItemClasses}
      disabled={disabled}
    >
      {children}
    </MuiMenuItem>
  );
}

export default React.forwardRef(MenuItem);
